import { Button, Modal, SearchSelect } from "@bcc-ui/ui-components";
import React from "react";
import { useTranslation } from "react-i18next";

import { AssetCustomView } from "domain/asset-management/assets";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onMove: (targetFolderUuid: string | null) => void;
    availableFolders: AssetCustomView[];
    currentViewUuid: string;
    viewName: string;
}

export const MoveToFolderModal = (props: Props) => {
    const { t } = useTranslation();
    const [selectedFolderUuid, setSelectedFolderUuid] = React.useState<string | null>(null);

    const folderItems = [
        { value: "", label: t("AssetManagement.moveToFolder.selectFolder") },
        ...props.availableFolders.map((folder) => ({ value: folder.uuid, label: folder.name })),
    ];

    const handleMove = () => {
        props.onMove(selectedFolderUuid || null);
        props.onClose();
    };

    return (
        <Modal
            title={t("AssetManagement.moveToFolder.menuItem")}
            isOpen={props.isOpen}
            hideModal={props.onClose}
            buttons={
                <>
                    <Button variant="Primary" onClick={handleMove}>
                        {t("Common.move")}
                    </Button>
                    <Button variant="Secondary" onClick={props.onClose}>
                        {t("Common.cancel")}
                    </Button>
                </>
            }
        >
            <SearchSelect
                name="folderSelect"
                label={t("AssetManagement.moveToFolder.move", { view: props.viewName })}
                placeholder={t("AssetManagement.moveToFolder.move")}
                selectedByDefault={selectedFolderUuid || ""}
                items={folderItems}
                onSelection={(value) => setSelectedFolderUuid(String(value) || null)}
                closeOnSelection={true}
            />
        </Modal>
    );
};
